import styled from "styled-components";
import { Colors } from "../../styles/consts";


export const Description = styled.p`
color: ${Colors.PRIMARY_COLOR_FONT};

font-size: 24px;

display: flex;



`
export const DescriptionDiv = styled.div`
`